import { forkJoin } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { ExerciseModel } from 'projects/core/src/lib/models/exercise.model';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CompetenceModel } from 'projects/core/src/lib/models/competence.model';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { TranslocoService } from '@ngneat/transloco';
import { BaseDetail } from 'projects/admin/src/app/classes/base-detail';
import { DetailModes } from 'projects/admin/src/app/shared/constants';
import { HelperService } from 'projects/admin/src/app/services/helper.service';

@Component({
  selector: 'app-exercise-detail',
  templateUrl: './exercise-detail.component.html',
  styleUrls: ['./exercise-detail.component.scss']
})
export class ExerciseDetailComponent extends BaseDetail implements OnInit {

  public exercise: ExerciseModel = null;
  public competences: Array<CompetenceModel> = [];
  public backRoute = ['/exercises'];

  protected identifier = 'exercise';

  constructor(
    protected ui: UiService,
    protected router: Router,
    protected helper: HelperService,
    protected transloco: TranslocoService,
    private api: ApiService,
    private route: ActivatedRoute,
  ) {
    super(ui, router, helper, transloco);
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params.id === 'new') {
        this.setInitialized(DetailModes.new);
      } else if (params.id) {
        this.setLoading();
        const optional: any = {};
        if (params.hashed_id) {
          optional.hashed_id = params.hashed_id;
        }
        forkJoin([
          this.api.getModel('exercises', params.id, optional),
          this.api.getModels('competences')
        ]).subscribe({
          next: (result: any) => {
            this.exercise = new ExerciseModel().deserialize(result[0].data);
            this.exercise.setTranslocoService(this.transloco);
            this.tabIndex = parseInt(localStorage.getItem(this.identifier + '-tab-' + this.exercise.id), 10);
            if (result[1] !== null && result[1].data.length > 0) {
              result[1].data.forEach((competence: any) => {
                this.competences.push(new CompetenceModel().deserialize(competence));
              });
            }
            this.setInitialized(DetailModes.edit);
          },
          error: (error: any) => {
            this.setFailed(error);
          }
        });
      }
    });
  }

  onTabChange(event: any): void {
    if (this.exercise !== null) {
      localStorage.setItem(this.identifier + '-tab-' + this.exercise.id, event.index);
    }
    this.ui.setFocus();
  }

}
